import { render, staticRenderFns } from "./DocumentOrganization.vue?vue&type=template&id=385fa42a&scoped=true&"
import script from "./DocumentOrganization.vue?vue&type=script&lang=js&"
export * from "./DocumentOrganization.vue?vue&type=script&lang=js&"
import style0 from "./DocumentOrganization.vue?vue&type=style&index=0&id=385fa42a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385fa42a",
  null
  
)

export default component.exports